import { render, staticRenderFns } from "./EditCutoverplanAttributeTab.vue?vue&type=template&id=1b0d6024&"
import script from "./EditCutoverplanAttributeTab.vue?vue&type=script&lang=ts&"
export * from "./EditCutoverplanAttributeTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports